"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSplitTreatmentWithSideEffect = exports.getSplitTreatment = exports.getWindowKeyForTrafficType = exports.getSegmentAnonymousId = exports.waitForTrafficTypeInitialization = void 0;
const client_1 = require("./client");
const browser_1 = require("../../helpers/browser");
const log_1 = require("../../helpers/log");
const constants_1 = require("./constants");
const newrelic_1 = require("./newrelic");
const validators_1 = require("./validators");
const waitForTrafficTypeInitialization = (trafficType, userSplitCredentials) => __awaiter(void 0, void 0, void 0, function* () {
  yield (0, client_1.initSplit)([trafficType], userSplitCredentials);
  let currentTry = 0;
  (0, log_1.debugLog)(`Checking if traffic type ${trafficType} is initialized`);
  while (!(0, validators_1.isTrafficTypeInitialized)(trafficType)) {
    (0, log_1.debugLog)(`Traffic type ${trafficType} is not initialized`);
    if (currentTry++ >= constants_1.SPLIT_CLIENT_INITIALIZATION_MAX_RETRIES) {
      (0, log_1.debugLog)(`Unable to initialize for traffic type ${trafficType} Split before max retries`);
      throw new Error(`Unable to initialize for traffic type ${trafficType} Split before max retries`);
    }
    yield new Promise(_resolve => {
      window.setTimeout(() => _resolve(null), 1000);
    });
  }
  (0, log_1.debugLog)(`Traffic type ${trafficType} is initialized`);
  return Promise.resolve();
});
exports.waitForTrafficTypeInitialization = waitForTrafficTypeInitialization;
const getSegmentAnonymousId = () => {
  const anonymousSegmentId = (0, browser_1.getCookie)(constants_1.SEGMENT_IO_ANONYMOUS_ID);
  if (!anonymousSegmentId) {
    return false;
  }
  return decodeURIComponent(anonymousSegmentId).replace(/"/g, '');
};
exports.getSegmentAnonymousId = getSegmentAnonymousId;
const getWindowKeyForTrafficType = trafficType => {
  const windowKeyForTrafficType = {
    [constants_1.SPLIT_TRAFFIC_TYPES.ANONYMOUS]: 'anonymousSplitClient',
    [constants_1.SPLIT_TRAFFIC_TYPES.MAGENTO]: 'magentoSplitClient'
  };
  if (!windowKeyForTrafficType[trafficType]) {
    throw new Error(`Unable to get window key for traffic type ${trafficType}`);
  }
  return windowKeyForTrafficType[trafficType];
};
exports.getWindowKeyForTrafficType = getWindowKeyForTrafficType;
const getSplitTreatment = (splitName, email, trafficType, userSplitCredentials) => __awaiter(void 0, void 0, void 0, function* () {
  if ((0, browser_1.isServerSideRendering)()) {
    return constants_1.SPLIT_IO_NOT_AVAILABLE;
  }
  (0, log_1.debugLog)(`Attempting to get split treatment: ${splitName} for traffic type: ${trafficType}`);
  if (!(0, validators_1.isTrafficTypeInitialized)(trafficType)) {
    try {
      yield (0, exports.waitForTrafficTypeInitialization)(trafficType, userSplitCredentials);
    } catch (e) {
      if (userSplitCredentials) {
        (0, newrelic_1.reportNRInitializationTimeout)(trafficType, userSplitCredentials.splitAnonymousUserKey, userSplitCredentials.splitMagentoUserKey, userSplitCredentials.splitMagentoEmail);
      }
      return constants_1.SPLIT_IO_NOT_AVAILABLE;
    }
  }
  // Always serve control treatment to bots
  const userAgent = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent;
  const botRegEx = /bot|google|baidu|bing|msn|teoma|slurp|yandex/i;
  if (userAgent && botRegEx.test(userAgent)) {
    return constants_1.SPLIT_IO_TREATMENT_CONTROL;
  }
  let treatment = '';
  const windowKey = (0, exports.getWindowKeyForTrafficType)(trafficType);
  if (email) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    treatment = window[windowKey].getTreatment(splitName, {
      email
    });
  } else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    treatment = window[windowKey].getTreatment(splitName);
  }
  return treatment;
});
exports.getSplitTreatment = getSplitTreatment;
const getSplitTreatmentWithSideEffect = function (splitName) {
  let cookieName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : splitName;
  let splitTrafficType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : constants_1.SPLIT_TRAFFIC_TYPES.MAGENTO;
  return (email, customerId, anonymousId) => __awaiter(void 0, void 0, void 0, function* () {
    const treatment = yield (0, exports.getSplitTreatment)(splitName, email, splitTrafficType, {
      splitAnonymousUserKey: anonymousId,
      splitMagentoUserKey: customerId,
      splitMagentoEmail: email
    });
    const isSplitOn = (0, client_1.splitSideEffects)(splitTrafficType, cookieName, treatment, {
      splitAnonymousUserKey: anonymousId,
      splitMagentoUserKey: customerId,
      splitMagentoEmail: email
    });
    return isSplitOn;
  });
};
exports.getSplitTreatmentWithSideEffect = getSplitTreatmentWithSideEffect;